export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10092.0f185ab7.jpg";